import { DEFAULT_COMPANY, DEFAULT_OFFICE } from '@/constants';
import actions from './actions';
import mutations from './mutations';

const state = {
  apiVersion: null,
  message: {
    timestamp: 0,
    title: '',
    message: '',
    type: '',
    counter: 0,
  },
  adminSelectedOffice: DEFAULT_OFFICE,
  adminSelectedCompany: DEFAULT_COMPANY,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./store/modules/global/index.js